import { useCallback, useState } from "react";

import { applyUpdate, checkForUpdate } from "./forceUpdate";

export function useForceUpdate() {
	const [showModal, setShowModal] = useState(false);

	const checkAndProceed = useCallback(async (onProceed: () => void) => {
		const needsUpdate = await checkForUpdate();

		if (needsUpdate) {
			setShowModal(true);
		} else {
			onProceed();
		}
	}, []);

	const handleReload = useCallback(() => {
		applyUpdate();
	}, []);

	return { showModal, checkAndProceed, handleReload };
}
